<script>
  import Layout from '~/Components/Layout/Layout'
  import LinkMolecule from '~/Components/Molecules/Link'
  import CardOrganism from '~/Components/Organisms/CardCollection'

  const cards = [
    {
      title: 'Just for you',
      content: 'We have put together a number of health and wellbeing resources for you to draw on during this time.',
      link: '/for-you',
      icon_url: '/static/icons/smart-watch.svg'
    },
    {
      title: 'For your career',
      content: 'We have put together this package allowing you to access the things that will be of most value to you.',
      link: '/for-your-career',
      icon_url: '/static/icons/career.svg'
    },
    {
      title: 'Mentors to help',
      content: 'Find a listening ear from some experts in the field to help you in steering your decisions ahead.',
      link: '/mentors',
      icon_url: '/static/icons/mentors.svg'
    }
  ]

</script>

<Layout>
  <section class="hero">
    <div class="hero__content">
      <h1 class="heading">Next4Me</h1>
      <p>Life throws twists and turns at us and sometimes the path we set out on changes. At next15 we know every business decision we make impacts the paths people have set out on. We have created Next4Me to ensure we are giving you the best possible start into what’s next for you.</p>
      <LinkMolecule className="large"  cta="Learn more" to="/onboarding" />
    </div>
    <div class="hero__image">
      <img src="/static/shapes/rectangle.svg" alt="" class="hero__background">
      <img src="/static/illustrations/ronald.svg" alt="" class="hero__illustration">
    </div>
  </section>
  <section class="cards">
    <div class="cards__content">
      <img src="/static/shapes/rectangle.svg" alt="" class="cards__background">
      <h1 class="heading">Choices for you</h1>
      <p>Next4Me is about providing you with support to get back on your journey as quickly as possible, making choices you are in control of. <br/><br/>You decide what’s going to help you personally and professionally.</p>
    </div>
    <CardOrganism {cards} />
  </section>
</Layout>

<style lang="scss">
  .hero {
    display: flex;
    padding: 8.625rem 0;
    position: relative;
    &__content {
      flex-basis: 50%;
      .heading {
        font-size: 5rem;
        line-height: 6.75rem;
        margin-bottom: 1.875rem;
      }
      p {
        margin-bottom: 1.375rem;
      }
    }
    &__image {
      position: relative;
      flex-basis: 50%;
    }
     &__background {
      position: absolute;
      height: 55rem;
      width: 55rem;
      bottom: -200px;
      left: 50px;
      z-index: -10;
    }

    @media only screen and (max-width: 576px) {
      flex-direction: column-reverse;
      padding: 0.5rem 0;
      margin-bottom: 8rem;
      &__content {
        .heading {
          font-size: 2.625rem;
          line-height: 3.5rem;
        }
      }
    }

  }
  .cards {
    &__content {
      position: relative;
      padding: 2rem 0;
      width: 55%;
      &::before {
        width: 5rem;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 2px;
        border-bottom: 2px solid var(--heading-colour);
      }
      .heading {
        margin-bottom: 1.875rem;
      }
      p {
        margin-bottom: 3rem;
      }
    }
    &__background {
      position: absolute;
      top: -100px;
      right: -70px;
      height: 55rem;
      width: 55rem;
      z-index: -10;
    }
    @media only screen and (max-width: 576px) {
      &__content {
        width: unset;
      }
    }
  }
</style>
